<template>
    <div>
        <Dropdown v-model="selectedOrg" :options="organizations" optionLabel="display_name" filter dataKey="id"
                  :placeholder="$t('AppOperations.Organização')" :class="[mobileView ? 'full-width' : 'dropdown-250']">
            <template #option="slotProps" style="width: 500px">
                {{ slotProps.option.display_name }}
            </template>
        </Dropdown>
        <Dropdown v-if="mobileView" v-model="selectedField" :options="fields" optionLabel="name" dataKey="id" filter
                  @change="onFieldSelection(false)"
                  :placeholder="$t('AppFieldsAsideMenu.Talhões')" class="full-width mt-2">
        </Dropdown>
        <Dropdown v-model="selectedOperation" :options="operations" optionLabel="display_name" filter dataKey="id"
                  :disabled="!operations.length" :placeholder="$t('AppOperations.Operação')"
                  :class="[mobileView ? 'full-width mt-2' : 'dropdown-250 ml-2']">
            <template #value="slotProps">
                <div v-if="slotProps.value">
                    <Badge :style="{ background: slotProps.value.color }" class="op-badge"/>
                    {{ slotProps.value.display_name }}
                </div>
            </template>
            <template #option="slotProps">
                <Badge :style="{ background: slotProps.option.color }" class="op-badge"/>
                {{ slotProps.option.display_name }}
            </template>
        </Dropdown>
        <Dropdown v-model="selectedMapType" :options="mapTypes" optionLabel="title" dataKey="value" filter
                  :disabled="!selectedOperation" :placeholder="$t('AppOperations.Tipo de mapa')"
                  :class="[mobileView ? 'full-width mt-2' : 'dropdown-250 ml-2']">
        </Dropdown>
        <Dropdown v-if="comparingOperations" v-model="compareOperationTwo" :options="operations" filter dataKey="id"
                  optionLabel="display_name" :placeholder="$t('AppOperations.Operação')"
                  :class="[mobileView ? 'full-width mt-2' : 'dropdown-250 ml-2']">
            <template #value="slotProps">
                <div v-if="slotProps.value">
                    <Badge :style="{ background: slotProps.value.color }" class="op-badge"/>
                    {{ slotProps.value.display_name }}
                </div>
            </template>
            <template #option="slotProps">
                <Badge :style="{ background: slotProps.option.color }" class="op-badge"/>
                {{ slotProps.option.display_name }}
            </template>
        </Dropdown>
        <Dropdown v-if="comparingOperations" v-model="selectedMapTypeTwo" :options="mapTypesTwo" filter dataKey="value"
                  optionLabel="title" :placeholder="$t('AppOperations.Tipo de mapa')"
                  :class="[mobileView ? 'full-width mt-2' : 'dropdown-250 ml-2']">
        </Dropdown>
    </div>
</template>

<script>

import FieldsService from "@/services/FieldsService";
import OperationsService from "@/services/OperationsService";
import OrganizationsService from "@/services/OrganizationsService";

import Button from "primevue/button";
import Badge from "primevue/badge";
import Menu from "primevue/menu";
import Dropdown from "primevue/dropdown";

import * as jsts from 'jsts';
import gmapsInit from "@/utils/gmaps";
import dateFormat from "@/mixins/DateMixin";
import jstsWithoutHolesToGoogleMaps from "@/mixins/GeometryMixin";
import {OPERATIONS_LIST} from "@/components/views/agriculture/AppAgricultureOptions";
import HourFormatMixin from "@/mixins/HourFormatMixin";

export default {
    mixins: [dateFormat, jstsWithoutHolesToGoogleMaps, HourFormatMixin],
    async mounted() {
        this.google_maps_reference = await gmapsInit();
        this.fieldsService = new FieldsService();
        this.operationsService = new OperationsService();
        this.organizationsService = new OrganizationsService();
        this.getOrganizations();
    },
    data() {
        return {
            fieldsService: null,
            operationsService: null,
            organizationsService: null,
            google_maps_reference: null,
            organizations: [],
            selectedOrg: null,
            fields: [],
            selectedField: null,
            fieldSelectedFromAsideMenu: false,
            operations: [],
            selectedOperation: null,
            selectedMapType: null,
            compareOperationTwo: null,
            selectedMapTypeTwo: null,
            loadingClients: false,
            loadingFields: false,
            loadingOperations: false
        }
    },
    methods: {
        getOrganizations() {
            this.loadingClients = true;
            this.organizationsService.getAllV3('AGRICULTURE')
                .then((response) => {
                    this.organizations = response.sort((a, b) => a.name.localeCompare(b.name));
                    this.selectOrganization();
                })
                .catch(() => {
                    this.$toast.add({
                        severity: 'error',
                        summary: this.$t('AppOperations.Não foi possivel buscar as organizações'),
                        life: 5000
                    });
                })
                .finally(() => {
                    this.loadingClients = false;
                })
        },
        selectOrganization() {
            if (this.organizations.length === 1) {
                this.selectedOrg = this.organizations[0];
                return;
            }

            let urlOrgId = this.$route.query.org_id;
            if (urlOrgId) {
                let foundOrg = this.organizations.find(obj => obj.id === urlOrgId);
                if (foundOrg) {
                    this.selectedOrg = foundOrg;
                }
                return;
            }

            let storedChosenOptions = JSON.parse(localStorage.getItem(process.env.VUE_APP_LOCAL_STORAGE_AGRO_FILTER_OPTIONS));
            if (!storedChosenOptions || !storedChosenOptions.selectedOrg) {
                return;
            }

            let foundOrg = this.organizations.find(obj => obj.id === storedChosenOptions.selectedOrg);
            if (foundOrg) {
                this.selectedOrg = foundOrg;
            }
        },
        clearData(selectedField) {
            this.operations = [];
            this.selectedOperation = null;
            this.selectedField = selectedField ?? null;
            this.$emit('exitCompare');
        },
        getFieldsFromOrg() {
            this.loadingFields = true;
            this.fields = [];
            this.fieldsService.getFieldsOperations(this.selectedOrg.id)
                .then((response) => {
                    let tmpFields = response.sort((a, b) => a.name.localeCompare(b.name));

                    tmpFields.forEach(field => {
                        field.area = this.calculateArea(field);
                        field.operationType = this.parseOperationType(field.last_operation);
                    })

                    this.fields = tmpFields;
                    this.selectField();
                    this.onFieldSelection(this.selectedField, false);
                })
                .catch((error) => {
                    if (!error.response || error.response.status !== 403) {
                        this.$toast.add({
                            severity: 'error',
                            summary: this.$t('AppOperations.Não foi possivel completar a operação, Tente novamente'),
                            life: 5000
                        });
                        return;
                    }
                    this.$toast.add({
                        severity: 'error',
                        summary: this.$t('AppOperations.Você não tem acesso a esta funcionalidade'),
                        life: 5000
                    });
                })
                .finally(() => {
                    this.loadingFields = false;
                })
        },
        calculateArea(field) {
            if (!field.coordinates) {
                return 0;
            }

            return (this.google_maps_reference.maps.geometry.spherical.computeArea(
                this.jstsWithoutHolesToGoogleMaps(this.buildPolygonFromCoordinates(field.coordinates),
                    this.google_maps_reference.maps)[0]) / 10000).toFixed(3);
        },
        buildPolygonFromCoordinates(wtkString) {
            let reader = new jsts.io.WKTReader();
            return reader.read(wtkString);
        },
        parseOperationType(last_operation) {
            let noOperationObj = {name: 'NONE', label: this.$t('AppOperations.Sem operação'), color: '#ffffff', group: 6}
            if (!last_operation) {
                return noOperationObj;
            }

            let foundOperation = OPERATIONS_LIST().find(op => op.name === last_operation);
            return foundOperation ?? noOperationObj;
        },
        onFieldSelection(field, fromAsideMenu) {
            if (fromAsideMenu) {
                this.selectedField = field;
            }
            this.fieldSelectedFromAsideMenu = fromAsideMenu;
            this.operations = [];
            this.selectedOperation = null;
            this.saveFilterOptions();
            this.calculateFieldCenter();
            this.getOperations();
        },
        selectField() {
            let urlFieldId = this.$route.query.field_id;
            if (urlFieldId) {
                let foundField = this.fields.find(obj => obj.id === urlFieldId);
                if (foundField) {
                    this.selectedField = foundField;
                    return;
                }
            }

            let storedChosenOptions = JSON.parse(localStorage.getItem(process.env.VUE_APP_LOCAL_STORAGE_AGRO_FILTER_OPTIONS));
            if (!storedChosenOptions || !storedChosenOptions.selectedField) {
                this.selectedField = this.fields[0];
                return;
            }

            let foundField = this.fields.find(obj => obj.id === storedChosenOptions.selectedField);
            if (foundField) {
                this.selectedField = foundField;
                return;
            }

            this.selectedField = this.fields[0];
        },
        calculateFieldCenter() {
            if (!this.selectedField.coordinates) {
                return;
            }

            let fieldPolygon = this.buildPolygonFromCoordinates(this.selectedField.coordinates);
            let envelopeCoordinates = (fieldPolygon.getEnvelope().getCoordinates())

            let maxLat = -90;
            let maxLng = -180;
            let minLat = 90;
            let minLng = 180;

            envelopeCoordinates.forEach(coordinate => {
                if (coordinate.y > maxLat) {
                    maxLat = coordinate.y;
                }
                if (coordinate.y < minLat) {
                    minLat = coordinate.y;
                }
                if (coordinate.x > maxLng) {
                    maxLng = coordinate.x;
                }
                if (coordinate.x < minLng) {
                    minLng = coordinate.x;
                }
            })

            this.fieldCenter = {lat: (maxLat + minLat) / 2, lng: (maxLng + minLng) / 2};
        },
        saveFilterOptions() {
            let storedChosenOptions = {
                selectedOrg: this.selectedOrg.id,
                selectedField: this.selectedField.id
            }
            localStorage.setItem(process.env.VUE_APP_LOCAL_STORAGE_AGRO_FILTER_OPTIONS, JSON.stringify(storedChosenOptions));
        },
        getOperations() {
            this.loadingOperations = true;
            this.operations = [];
            this.operationsService.getOperations(this.selectedField.id)
                .then(async (result) => {
                    this.parseOperations(result);
                    await this.$emit('initTimeline');
                    this.selectOperation();
                })
                .catch(() => {
                    this.$toast.add({
                        severity: 'error',
                        summary: this.$t('AppOperations.Não foi possível buscar as operações associadas a este talhão'),
                        life: 5000
                    });
                })
                .finally(() => {
                    this.loadingOperations = false;
                })
        },
        parseOperations(response) {
            let itemsTemp = [];

            response.forEach(operation => {
                itemsTemp.push({
                    id: operation.id,
                    type: 'range',
                    operation_type: operation.operation_type,
                    name: this.getOperationData(operation.operation_type, 'label'),
                    className: 'operation-analyze-' + operation.operation_type.toLowerCase(),
                    group: this.getOperationData(operation.operation_type, 'group'),
                    start: new Date(operation.start_date * 1000),
                    end: new Date(operation.end_date * 1000),
                    length: operation.end_date - operation.start_date,
                    imgSrc: this.getOperationData(operation.operation_type, 'src'),
                    color: this.getOperationData(operation.operation_type, 'color')
                })
            })

            itemsTemp.forEach(item => {
                item.display_name = this.formatDropdownContent(item);
                item.content = this.createTimelineContent(item.imgSrc);
            })

            itemsTemp = itemsTemp.sort((a, b) => b.end - a.end);
            this.operations = itemsTemp;
        },
        getOperationData(operationType, data) {
            for (const element of OPERATIONS_LIST()) {
                if (element.name === operationType) {
                    return element[data];
                }
            }

            switch (data) {
                case 'src':
                    return require("../../../../assets/icons/icone-task.svg");
                case 'label':
                    return '---';
                case 'group':
                    return 0;
                case 'color':
                    return '#fff';
            }
        },
        formatDropdownContent(operation) {
            let fStartDate = this.dateFormat(operation.start.valueOf() / 1000);
            let fEndDate = this.dateFormat(operation.end.valueOf() / 1000);
            return `${operation.name} - ${fStartDate} ${this.$t('AppOperations.a')} ${fEndDate}`;
        },
        createTimelineContent(src) {
            let wrapper = document.createElement("div");
            let content = document.createElement("div");

            content.textContent = '';
            wrapper.appendChild(content);

            let wrapperImg = document.createElement("div");

            let img = document.createElement("IMG");
            img.src = src;
            img.width = "25";
            wrapperImg.appendChild(img);

            wrapper.appendChild(wrapperImg);

            return wrapper;
        },
        selectOperationFromTimeline(operation) {
            this.selectedOperation = operation;
        },
        selectOperation() {
            if (this.operations.length === 0 || this.selectedOperation) {
                this.updateQuery();
                return;
            }

            let urlOperationId = this.$route.query.operation_id;
            let foundOperation;
            if (urlOperationId) {
                foundOperation = this.operations.find(op => op.id === urlOperationId);
            }

            this.selectedOperation = foundOperation ?? this.operations[0];
        },
        updateQuery() {
            let query = this.buildCurrentQuery();
            if (JSON.stringify(this.$route.query) === JSON.stringify(query)) {
                return;
            }

            this.$router.replace({...this.$router.currentRoute, query: query});
        },
        buildCurrentQuery() {
            let query = {
                org_id: this.selectedOrg.id,
                field_id: this.selectedField.id
            }

            if (this.selectedOperation) {
                query.operation_id = this.selectedOperation.id;
            }

            return query;
        },
        setSelectedMapType(selectedMapType) {
            this.selectedMapType = selectedMapType;
        },
        setCompareOperationTwo(compareOperationTwo) {
            this.compareOperationTwo = compareOperationTwo;
        },
        setSelectedMapTypeTwo(selectedMapTypeTwo) {
            this.selectedMapTypeTwo = selectedMapTypeTwo;
        }
    },
    props: {
        mapTypes: {
            type: Array,
            default() {
                return [];
            }
        },
        mapTypesTwo: {
            type: Array,
            default() {
                return [];
            }
        },
        comparingOperations: {
            type: Boolean
        },
        mobileView: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        loading: function () {
            this.$emit('updateLoading', this.loading);
        },
        selectedOrg: function () {
            if (this.selectedOrg) {
                this.applyHourFormatFromOrganizations(this.selectedOrg, this.organizations);
                this.$emit('selectedOrg', this.selectedOrg);
                this.clearData();
                this.getFieldsFromOrg();
            }
        },
        fields: function () {
            this.$emit('fields', this.fields)
        },
        selectedField: function () {
            if (!this.fieldSelectedFromAsideMenu && this.selectedField) {
                this.$emit('selectedField', this.selectedField, false);
            }
        },
        operations: function () {
            this.$emit('operations', this.operations);
        },
        selectedOperation: function () {
            this.$emit('selectedOperation', this.selectedOperation);
        },
        selectedMapType: function () {
            this.$emit('updateSelectedMapType', this.selectedMapType);
        },
        compareOperationTwo: function () {
            this.$emit('updateCompareOperationTwo', this.compareOperationTwo);
        },
        selectedMapTypeTwo: function () {
            this.$emit('updateSelectedMapTypeTwo', this.selectedMapTypeTwo);
        }
    },
    computed: {
        loading: function () {
            return this.loadingOperations || this.loadingFields || this.loadingClients;
        }
    },
    components: {
        Button,
        Badge,
        Menu,
        Dropdown
    }
}
</script>

<style scoped>
.full-width {
    width: 100%;
}

.dropdown-250 {
    width: 250px;
}

.op-badge {
    padding: 0.325rem;
    margin: 0 0.25rem 0 0;
}
</style>
